import React from 'react';
import PropTypes from 'prop-types';
import GmInfoTooltip from 'react/components/Tooltip';

const MultipleField = ({
  children,
  placeholder,
  defaultValueField,
  openModalButton,
  tooltipResource
}) => (
  <div className="multipleFieldWrapper">
    <div className="multipleField">
      {children}
      <div className="arrowRight" />
      <div className="gmValuesInfo">
        <input
          type="text"
          placeholder={placeholder}
          readOnly
          className="disabled"
        />
        {tooltipResource && <GmInfoTooltip resource={tooltipResource} />}
      </div>
      {defaultValueField && defaultValueField()}
    </div>
    {openModalButton && openModalButton()}
  </div>
);

MultipleField.propTypes = {
  children: PropTypes.node.isRequired,
  placeholder: PropTypes.string,
  defaultValueField: PropTypes.func,
  openModalButton: PropTypes.func,
  tooltipResource: PropTypes.string
};

MultipleField.defaultProps = {
  placeholder: null,
  defaultValueField: null,
  openModalButton: null,
  tooltipResource: null
};

export default MultipleField;
